import { useState, ReactNode } from 'react'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { Box, BoxProps, Divider, IconButton, Stack } from '@mui/material'

const defaultBoxProps: BoxProps = {
  sx: {
    paddingLeft: 0.5,
    paddingRight: 0.5,
    paddingTop: 0,
    paddingBottom: 0,
  },
}

interface Props {
  /** Optional text shown in the divider (e.g. section label). */
  text?: ReactNode
  defaultExpanded?: boolean
  children: ReactNode
  'data-cy'?: string
  boxProps?: BoxProps
}

const CollapsibleDivider = ({
  text,
  defaultExpanded = false,
  children,
  'data-cy': dataCy,
  boxProps = {},
}: Props) => {
  const [expanded, setExpanded] = useState(defaultExpanded)

  return (
    <Stack direction="column" spacing={0} width="100%">
      <Stack direction="row" alignItems="center" width="100%">
        <IconButton
          size="small"
          onClick={() => setExpanded(prev => !prev)}
          aria-expanded={expanded}
          sx={{ padding: 0 }}
          data-cy={dataCy}
        >
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
        <Divider textAlign="center" sx={{ width: '95%' }}>
          {text}
        </Divider>
      </Stack>
      <Box {...defaultBoxProps} {...boxProps}>
        {expanded && children}
      </Box>
    </Stack>
  )
}

export default CollapsibleDivider
